// format indonesia
export function getDateTodayId (date) {
  const bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
  var today = date || new Date();
  var xhari = today.getDate();
  var xbulan = today.getMonth();
  var xtahun = today.getYear();
  var tahun = (xtahun < 1000) ? xtahun + 1900 : xtahun;
  return xhari + ' ' + bulan[xbulan] + ' ' + tahun;
}